exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#segment-check-view .class-code-input-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  #segment-check-view .class-code-input-group .class-code-input {\n    text-align: center; }\n  #segment-check-view .class-code-input-group .glyphicon {\n    width: 0;\n    line-height: 40px;\n    font-size: 30px; }\n\n#segment-check-view .classroom-name {\n  font-size: 26pt; }\n\n#segment-check-view .teacher-name {\n  font-size: 14pt; }\n\n#segment-check-view .parent_birthdate {\n  font-size: 11pt;\n  margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/segment-check-view.sass
// module id = 814
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91